<div class="modal-body barcode">
  <form #modalForm="ngForm" novalidate>
    <div class="form-group row">
      <label for="search_type" class="col-md-4 col-sm-12">
        <small>Arama Türü</small>
      </label>
      <div class="col-md-8 col-sm-12">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          [options]="searchTypeOpt"
          #searchType="ngModel"
          [(ngModel)]="searchTypeValue"
          name="search_type"
          id="search_type"
          [style]="{ width: '100%' }"
          required
        >
        </p-dropdown>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-4 col-sm-12" for="search_text">
        <small>Aranacak Değer</small>
      </label>
      <div class="col-md-8 col-sm-12">
        <input
          class="form-control form-control-sm"
          id="search_text"
          #focusElement
          (keydown)="keydown($event)"
          maxlength="20"
          [(ngModel)]="materialValue"
          name="search_text"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-4 col-sm-12" for="material_description">
        <small>Malzeme Açıklaması</small>
      </label>
      <div class="col-md-8 col-sm-12">
        <input
          class="form-control form-control-sm"
          id="material_description"
          disabled
          [value]="materialDescription"
          name="search_text"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-4 col-sm-12" for="search_amount">
        <small>Miktar</small>
      </label>
      <div class="col-md-8 col-sm-12">
        <wj-input-number
          [(value)]="materialQuantity"
          [format]="'n2'"
          id="search_amount"
          (keydown)="keydown($event)"
          [min]="1"
          class="form-control form-control-sm"
          [showSpinner]="false"
        ></wj-input-number>
      </div>
    </div>
  </form>
  <div class="material-entry-error-message" *ngIf="alertShow">
    <kl-alert
      [show]="alertShow"
      [type]="alertType"
      [message]="alertMessage"
      (onClose)="alertShow = false"
    ></kl-alert>
  </div>
</div>
<div class="modal-footer">
  <div class="pull-right">
    <button
      class="btn btn-sm btn-greenish setForm"
      [disabled]="!setform"
      (click)="setForm()"
    >
      {{ "add_line" | translate }}
    </button>
    <button class="btn btn-sm btn-default setCancel" (click)="hide()">
      {{ "cancel" | translate }}
    </button>
  </div>
</div>
